export interface ClientAccountDeed {
    id?: string | null;
    date?: string | Date | null;
    partnerPracticeReference: string | null;
    rightLegalReference: string | null;
    nameOnDeed: string | null;
    isLandRegistered: boolean;
    addressLine1: string | null;
    addressLine2: string | null;
    addressLine3: string | null;
    town: string | null;
    county: string | null;
    postcode: string | null;
    version?: number;

}

export function createClientAccountDeed(): ClientAccountDeed {
    return {
        partnerPracticeReference: null,
        rightLegalReference: null,
        isLandRegistered: false,
        nameOnDeed: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        town: null,
        county: null,
        postcode: null,
    };
}
